import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import api from '../../store/api';
import Navbar from '../shared/Navbar';
import { IAppPropsWithRoute } from '../../common/types';
import Button from "@material-ui/core/Button";
import { Theme } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from "@material-ui/core/styles";
import TransferDetailsWidget from './TransferDetailsWidget';
import TransferFullDetailsWidget from './TransferFullDetailWidget';
import { useHistory } from "react-router-dom";
import RightHandMenu from '../shared/RightHandMenu';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ClearIcon from '@material-ui/icons/Clear';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';

interface TransferPageProps extends IAppPropsWithRoute {

};

const useStylesNav = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        backgroundColor: '#0049a3'
    },
    logo: {

        display: "flex",
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    logoImg: {
        width: 236,
    },
    navBarElements: {
        fontSize: '18'
    },
    toolbar: {
        padding: 0,
        height: 59,
    },
    leftHandMenu: {
        height: '100%'
    },
    rightHandMenu: {
        height: '100%',
        display: "flex",
        justifyContent: "flex-end"
    },
    rightHandMenuButton: {
        color: '#fff',
    },
  
}));
const useStyles = makeStyles((theme: Theme) => ({
    dialogPaper: {
        minWidth: 500,
        margin: 0,
        borderRadius: 0,
        shadow: 'none',
        backgroundColor: '#fff',
    },

    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 30,
    },
    modalTitle: {
        fontSize: 19,
        color: '#03090E',
    },
    button: {
        width: '100%',
    },
}));
function NavLeftMenu({ leftButtonClick, title, show }: any): JSX.Element {
    const classes = useStylesNav();
    const history = useHistory();
    return (
        <div className={classes.leftHandMenu}>
            <Button style={{ height: '100%', color: '#FFF', display: 'flex', justifyContent: 'flex-start' }} onClick={() => { history.goBack() }} endIcon={<ArrowBackIosIcon />} ></Button>
        </div>
    )
}

function TransferDetailsPage(props: TransferPageProps): JSX.Element {
    const { bookingid, transferid, pageNumber } = useParams<{ bookingid: string, transferid: string, pageNumber: string }>();
    const [invalidBookingID, setInvalidBookingID] = useState(false);
    const transferData = React.useState({});
    const [estimatedEvents, setEstimatedEvents] = React.useState<any[]>([]);
    const [tripEvents, settripEvents] = React.useState<any[]>([]);
    const [page, setPage] = React.useState<any>(0);
    const classes = useStyles();
    
    const detailView = props.location.pathname.split('/')[1] === 'transferFullDetails' ? true : false;
    const history = useHistory();
    const [reasonForDelay, setReasonForDelay] = React.useState([]);
    const getScheduleTransferDetails = async () => {
        api.getScheduleTransferDetails(`transferId=${transferid}&bookingId=${bookingid}&version=${Math.random().toString()+Math.random().toString()+Math.random().toString()}`).then((result: any) => {
           
            if (!result.errorRaised && !result.hasError) {           
                const statusMap: any = { 7: true, 8: true, 9: true, 4: true };
                setEstimatedEvents(result.model?.tripDurationEstimations || []);
                settripEvents(result.model?.tripEvents.filter((item: any) => statusMap[item.status] === true) || [])
                transferData[1](result.model);                             
            }
            else {
                //console.log(result);
                console.log(result.error);
                console.log(result.errorMessage);
                setInvalidBookingID(true);
            }
        }).catch((error) => {
         
            console.log(error);
        })
    }

    const getReasonsForDelay = () => {
      api.getReasonsForDelayPerUser("").then((res: any) => {
        setReasonForDelay(res?.data?.model || []);
      });
    };

    useEffect(() => {
        setPage(pageNumber)
        getScheduleTransferDetails();
        getReasonsForDelay();
    }, [])

    return (
        <React.Fragment>
            {transferData[0] ?
                <div style={{ backgroundColor: detailView ? 'white' : '#00152e', height: '100vh' }}>
                    {
                        detailView ?
                            <Navbar rightButton={<RightHandMenu />} />
                            :
                            <Navbar rightButton={<RightHandMenu />} humberMenu={<NavLeftMenu title='' />} />
                    }

                    <div style={{ display: "flex", flex: 1, flexDirection: "row", backgroundColor: detailView ? 'white' : '#00152e' }}>
                        {detailView ? <TransferFullDetailsWidget transferData={transferData[0]} estimatedEvents={estimatedEvents} tripEvents={tripEvents} reasonForDelay={reasonForDelay} setPage={setPage} pageNumber = {props?.match?.params?.pageNumber}  /> : <TransferDetailsWidget transferData={transferData[0]} getScheduleTransferDetails={getScheduleTransferDetails} reasonForDelay={reasonForDelay} />}
                    </div>

                </div>
                : null}
            <Dialog classes={{ paper: classes.dialogPaper }} maxWidth="sm" open={invalidBookingID} onClose={() => null} aria-labelledby="form-dialog-title">

                <DialogContent>
                    <div className={classes.header}>
                        <div className={classes.modalTitle}>Some Error Occured</div>
                        <ClearIcon onClick={() => history.push('/transferschedule')} style={{ cursor: "pointer" }} />
                    </div>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={8}>

                        </Grid>
                    </Grid>
                    <div style={{ margin: '10px 0px 10px 0px' }}>
                        Provided booking ID is not valid.
                        </div>
                </DialogContent>

                <DialogActions>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <Button className={classes.button} onClick={() => history.push('/')} style={{ fontWeight: 'bold', backgroundColor: '#ECECEC', color: '#090F15' }} color="primary">
                                Go To Home
                                </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button className={classes.button} disabled={false} onClick={() => history.push('/transferschedule')}
                                type='submit' style={{ fontWeight: 'bold' }} color="primary">
                                Go to Tranfers
                                </Button>
                        </Grid>
                    </Grid>
                </DialogActions>

            </Dialog>
        </React.Fragment>
    );
}

export default React.memo(TransferDetailsPage);
